import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceExportExcel } from 'src/app/core/services/export.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-zone-shift-mapping',
  templateUrl: './zone-shift-mapping.component.html',
  styleUrls: ['./zone-shift-mapping.component.scss']
})
export class ZoneShiftMappingComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mCity = new FormControl('');
  public mSite = new FormControl('');
  public mFilterTypeValue: any = new FormControl('');
  public mRouteType = new FormControl('');

  routetype: any = [];
  masterZones = [];
  shifts = [];
  sites: any = [];
  cities: any = [];
  selrows = [];
  pushedValues: any[] = [];
  unPushedValues: any[] = [];
  shiftmapping: any = [];

  constructor(private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private readonly serviceExportExcel: ServiceExportExcel,
    private readonly localStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService
  ) {
    this._mFormGroup = this.fb.group({
      'city': this.mCity,
      'site': this.mSite,
      'filterTypeValue': this.mFilterTypeValue,
      'routeType': this.mRouteType
    });
  }

  ngOnInit() {
    this.loadRoutePriority();
    this.loadCities();
  }

  loadCities() {
    let companyid: number = +this.localStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyid, success => {
      this.cities = success.body;
      if (this.cities.length > 0) {
        this.mCity.setValue(this.cities[0].locationId);
        this.getSitesByCityId({ target: { value: this.cities[0].locationId } });
      }
    }, (error) => {
    });
  }

  loadRoutePriority() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getAllRoutePriority, success => {
      if (success.status == 200) {
        this.routetype = success.body;
        if (this.routetype.length > 0) {
          setTimeout(() => {
            this.mRouteType.setValue(this.routetype[0].type);
          });
        }
      }
    }, (error) => {
    });
  }

  getSitesByCityId(event) {
    const cityId = event?.target?.value;
    if (cityId) {
      this.apiService.doGetRequestWithResponse(
        ApiConstants.getserchsitelist + cityId,
        (success) => {
          this.sites = success?.body || [];
          if (this.sites.length > 0) {
            this.mSite.setValue(this.sites[0].siteId);
            this.onsitechange({ target: { value: this.sites[0].siteId } });
          }
        },
        (error) => { }
      );
    }
  }

  onsitechange(event) {
    const siteValue = event?.target?.value;
    if (siteValue) {
      this.mFilterTypeValue.setValue([]);
      this.resetvalues();
      this.getMasterZone();
      this.getShiftTime();
      this.getZoneShiftMapping(0);
    }
  }

  getMasterZone() {
    this.apiService.doGetRequestWithResponse(
      ApiConstants.masterZone + this.mSite.value,
      (success) => {
        this.masterZones = success?.status === 200
          ? success.body.map(mzone => ({ id: mzone.id, value: mzone.name }))
          : [];
      },
      (error) => this.masterZones = []
    );
  }

  getShiftTime() {
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getShiftsBySiteAndTypeV3}${this.mSite.value}&shifttype=General`,
      (success) => {
        if (success?.body) {
          this.shifts = success.body.map(shift => ({
            id: shift.shiftTimeId,
            value: `${shift.shiftTime} ${shift.logType}`
          }));
          if (this.shifts.length > 0) {
            this.mFilterTypeValue.setValue([this.shifts[0].id]);
          }
        } else {
          this.shifts = [];
          this.notifyService.showInfo("No shift time found", null);
        }
      },
      (error) => this.shifts = []
    );
  }

  showMapping() {
    this.pushedValues = [];
    this.unPushedValues = [];
    this.selrows = [];
    const validations = [
      { field: this.mCity.value, message: "Please select the city" },
      { field: this.mSite.value, message: "Please select the site" },
      { field: this.mFilterTypeValue.value, message: "Please select filter type value" },
      { field: this.mRouteType.value, message: "Please select route type" }
    ];

    const failedValidation = validations.find(v => !v.field);
    if (failedValidation) {
      this.notifyService.showWarning(failedValidation.message, null);
      return;
    }

    if (!this.mRouteType.value) return;
    this.pushedValues = [];
    this.unPushedValues = [];
    this.selrows = [];
    this.selrows = this.masterZones;
    if (this.mFilterTypeValue.value.length > 1) {
      this.getZoneShiftMapping(0);
    } else {
      this.getMappingByShift();
      this.getZoneShiftMapping(this.mFilterTypeValue.value);
    }
  }

  getMappingByShift() {
    this.pushedValues = [];
    this.unPushedValues = [];
    this.apiService.doGetRequestWithResponse(ApiConstants.getzonebyshift + '?shiftid=' + this.mFilterTypeValue.value + '&siteid=' + this.mSite.value, (success) => {
      if (success.status == 200) {
        success.body.forEach(element => {
          element.zoneShifts.forEach(zoneShift => {
            if (zoneShift.shift.shiftTimeId == this.mFilterTypeValue.value && zoneShift.type == this.mRouteType.value) {
              let sel = {
                id: element.id,
                value: element.name,
              };
              this.pushedValues.push(sel);
              this.selrows = this.selrows.filter(r => r.id !== sel.id);
              this.unPushedValues.push(sel);
              this.unPushedValues.forEach(x => {
                x.state = 'checked'
              });
            }
          })
        });
      }
    }, (error) => {
    });
  }

  checkAll(checks) {
    if (checks.checked) {
      this.selrows.forEach(x => {
        x.state = checks.checked
        this.onValueChecked({ checked: true }, x);
      })
    }
  }

  unCheckAll(checks) {
    if (!checks.checked) {
      this.unPushedValues.forEach(x => {
        x.state = checks.checked
        this.onSelValuesChecked({ checked: false }, x);
      })
    }
  }

  onSelValuesChecked(checked, unselect) {
    if (!checked.checked) {
      this.selrows.push(unselect);
      this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
      this.pushedValues.push(unselect);
    }
  }

  onValueChecked(checked, sel) {
    if (!checked.checked) return;
    if (this.pushedValues.length >= 1) {
      this.notifyService.showWarning("Sorry, Only one master zone can map to shift time", null);
      return;
    }

    this.pushedValues.push(sel);
    this.selrows = this.selrows.filter(r => r.id !== sel.id);
    this.unPushedValues.push(sel);
  }

  onSelValueChecked(checked, unselect) {
    if (!checked.checked) {
      this.selrows.push(unselect);
      this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
      this.pushedValues = [];
    }
  }

  resetvalues() {
    this.pushedValues = [];
    this.unPushedValues = [];
    this.selrows = [];
  }

  saveMapping() {
    const validations = [
      { condition: this.mFilterTypeValue.value.length < 1, message: "please select zone/shift time" },
      { condition: this.mRouteType.value == '', message: "please select route type" }
    ];
    const failedValidation = validations.find(v => v.condition);
    if (failedValidation) {
      this.notifyService.showInfo(failedValidation.message, null);
      return;
    }

    if (this.unPushedValues.length === 0 && !confirm("Do you want to remove mapping?")) {
      return;
    }
    const zoneids = this.unPushedValues.map(item => +item.id);
    const shiftids = this.mFilterTypeValue.value.map(item => +item);
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(
      `${ApiConstants.updateshiftmap}${zoneids}&shiftids=${shiftids}&type=${this.mRouteType.value}`,
      '',
      (success) => {
        this.ngxLoader.stop();
        if (success?.status === 202) {
          this.notifyService.showSuccess(success.body.message, null);
          this.ngOnInit();
          this.resetvalues();
          this.mCity.setValue("");
          this.mSite.setValue("");
          this.mRouteType.setValue("");
          this.mFilterTypeValue.setValue("");
          this.pushedValues = [];
          this.unPushedValues = [];
          this.selrows = [];
          this.shiftmapping = [];
        }
      },
      (error) => {
        this.ngxLoader.stop();
      }
    );
  }

  getZoneShiftMapping(shift) {
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getzoneshiftmap}?siteid=${this.mSite.value}&shiftId=${shift}`,
      (success) => {
        if (success?.status === 200) {
          this.shiftmapping = success.body;
        } else if (success?.status === 204) {
          this.shiftmapping = [];
          // this.notifyService.showInfo("Mapping not found", null);
        } else {
          this.notifyService.showError("Error occurred", null);
        }
      },
      (error) => { }
    );
  }

  exportAsXLSX(): void {
    this.serviceExportExcel.exportAsExcelFile(this.shiftmapping, 'MasterZoneShiftMapping');
  }

  removeMapping(data, status) {
    let msg: any;
    let msgKey: any;
    if (status == 'Removed') {
      msg = "WARNING: Are you sure you want to remove Mapping?";
      msgKey = status;
    }
    data.status = msgKey;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: msg,
      text: status,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
    }).then(result => {
      if (result.value) {
        this.apiService.doPostRequestWithResponse(
          `${ApiConstants.removeZoneShift}${data.zoneShiftId}`,
          '',
          (success) => {
            if (success?.status === 200) {
              this.getZoneShiftMapping(0);
            }
          },
          (error) => { }
        );
        swalWithBootstrapButtons.fire('Done', 'Mapping removed successfully', 'success');
      } else {
        swalWithBootstrapButtons.fire('Cancelled', 'Failed to remove mapping', 'error');
        data.status = data.status === AppConstants.ACTIVE_STATUS
          ? AppConstants.DEACTIVE_STATUS
          : AppConstants.ACTIVE_STATUS;
      }
    });
  }
}